import HiddenInputText from './behaviors/hiddentextedit/HiddenTextEdit.js';
export default HiddenInputText;